import { createRequestTypes } from '../utils';

export const ORDER_PRODUCT_LIST = createRequestTypes('orderProduct/ORDER_PRODUCT_LIST');
export const ORDER_PRODUCT_LIST_FOR_ORDER = createRequestTypes('orderProduct/ORDER_PRODUCT_LIST_FOR_ORDER');
export const ORDER_PRODUCT_LIST_FOR_PRODUCT = createRequestTypes('orderProduct/ORDER_PRODUCT_LIST_FOR_PRODUCT');
export const DELETE_ORDER_PRODUCT = createRequestTypes('orderProduct/DELETE_ORDER_PRODUCT');

